import noop from "../lib/core/functional/noop.js";
import loadExternalResource from "./loadExternalResource";

function loadTag(src, callback, onError) {
    const selector = `script[src="${src}"]`;
    const element = document.createElement("script");
    element.src = src;
    element.async = true;
    loadExternalResource(selector, element, callback || noop, onError || noop);
}

export default function loadExternalScript(src, callback, onError) {
    loadTag(src, callback, onError);
}
